export enum QUERY_KEYS {
  createAdmissionPreset = 'create-admission-preset',
  deleteAdmissionPreset = 'delete-admission-preset',
  editAdmissionPreset = 'edit-admission-preset',
  getAdmissionsPresets = 'get-admissions-presets',
  getAdmissionsPresetsByType = 'get-admissions-presets-type',
  getPresetChannelsById = 'preset-channels-by-id',
}
